import React from 'react';
import { SearchBox } from 'react-instantsearch';
import SvgSearch from "../../../assets/icons/SvgSearch";

let timerId = undefined;
let timeout = 500;

function debounceSearchInput(query, search) {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), timeout);
}

export default function SearchBoxComponent() {
  return (
      <div className="flex w-full items-center self-center rounded-full bg-white py-3 px-4 sm:px-5 md:px-8 mt-12 md:mt-20 mx-8 sm:mx-auto lg:max-w-[80%] sm:max-w-[85%]">
        <SearchBox
            classNames={{
              root: "w-full",
              form: "w-full flex items-center",
              input: "w-full border-0 focus:ring-0 focus:outline-none h-8 sm:h-10 md:h-12 pl-4 rounded-full text-md bg-transparent placeholder-gray-500"
            }}
            queryHook={debounceSearchInput}
            placeholder='Try "Jacket" or other item'
            submitIconComponent={() => (
                <div className="hidden md:flex h-full items-center justify-center ml-5">
                  <button
                      className="rounded-full px-6 h-10 sm:h-12 md:h-14 my-auto text-sm bg-[#f1f1f1] cursor-pointer hover:scale-105 transition-transform duration-150 ease-linear flex items-center justify-center space-x-2 font-bold">
                    <SvgSearch />
                    <span>Search</span>
                  </button>
                </div>
            )}
            resetIconComponent={() => (
                <span className="text-black font-black text-base ml-4 hover:text-gray-700">X</span>
            )}
        />
      </div>
  );
}
